// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentType, type ComponentProps } from 'react';
import noop from 'lodash/noop';
import { EngagementSpotlight } from '@atlassiansox/engagekit-ts';
import {
	SpotlightTarget as SpotlightTargetDI,
	// @ts-expect-error - TS2305 - Module '"@atlaskit/onboarding"' has no exported member 'SpotlightTargetProps'.
	type SpotlightTargetProps,
} from '@atlaskit/onboarding';
import { PopupIntegrationDI } from '@atlassian/jira-atlassian-switcher-common-integration-view';
import {
	AtlassianSwitcherIntegration as AtlassianSwitcherIntegrationDI,
	type AtlassianSwitcherIntegrationProps,
} from '@atlassian/jira-atlassian-switcher-integration';
import type { IntegrationViewRendererProps } from '@atlassian/jira-atlassian-switcher-integration/src/types';
import { TenantContextSubscriber as TenantContextSubscriberDI } from '@atlassian/jira-tenant-context-controller';
import { APP_SWITCHER_SPOTLIGHT_KEY } from './constants';

type Props = {
	isOpen: boolean;
	AtlassianSwitcherIntegration?: ComponentType<AtlassianSwitcherIntegrationProps>;
	IntegrationViewRenderer?: ComponentType<IntegrationViewRendererProps>;
	SpotlightTarget?: ComponentType<SpotlightTargetProps>;
	TenantContextSubscriber?: ComponentType<
		JSX.LibraryManagedAttributes<
			typeof TenantContextSubscriberDI,
			ComponentProps<typeof TenantContextSubscriberDI>
		>
	>;
	onClose: () => void;
	onOpen: () => void;
};

export const AppSwitcher = ({
	AtlassianSwitcherIntegration = AtlassianSwitcherIntegrationDI,
	isOpen,
	onClose,
	onOpen,
	IntegrationViewRenderer = PopupIntegrationDI,
	SpotlightTarget = SpotlightTargetDI,
	TenantContextSubscriber = TenantContextSubscriberDI,
}: Props) => (
	<>
		<SpotlightTarget name={APP_SWITCHER_SPOTLIGHT_KEY}>
			<AtlassianSwitcherIntegration
				isOpen={isOpen}
				onOpen={onOpen}
				onClose={onClose}
				onCloseComplete={noop}
				TenantContextSubscriber={TenantContextSubscriber}
				IntegrationViewRenderer={IntegrationViewRenderer}
			/>
		</SpotlightTarget>
		<EngagementSpotlight engagementId={APP_SWITCHER_SPOTLIGHT_KEY} />
	</>
);

export default AppSwitcher;
